import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import { Personality } from "@/employee/Personality"

export class ShyPersonality extends Personality {
    id: string = 'shy'
    affix: string = 'prefix'

    description(): string {
      return `Shy characters require higher lust to interact with, and has slower lust generation.`
    }

    get constantMods(): { [key: string]: [ValueMod] } {
      return {
        "sexReqLust": [new ValueMod(2, 'mul')],
        "cuddleReqLust": [new ValueMod(20, 'add')]
      }
    }

    onUpdate(dt: number, employee: Employee) {
      employee.lustDelta.valueMods["shy"] = new ValueMod(0.5, 'mul')
    }
}
